// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 471 ? "67e56481" : chunkId) + "." + {"262":"d7e43473563d7e34","471":"283afafaac97e80e"}[chunkId] + ".js";
};